type ValueWrapper<T> = { value: T };

export function unwrapValue<T>(wrapper: ValueWrapper<T>): T {
  return wrapper.value;
}